import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from "../config"
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const getUser = (id) => {
    let reqid=id
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const token=getTokenfromUserObj()
    useEffect(() => {
        const get = async (id) => {
          try {
            const res = await axios.get(`${app.URL}/user/getuser/${id}`,{headers:{auth:token}});
            setResponse(res.data);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        get(reqid);
      }, []);
    
      return { loading, response, error };
    };
export default getUser